'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialAngularOutline = function IoSocialAngularOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 5l-14.7 5.4 3.1 18 11.6 6.2 11.6-6.2 3.1-18z m0-2.5l17.5 6.3-3.6 21.2-13.9 7.5-13.9-7.5-3.6-21.2z m6.9 25l-2.1-4.4h-9.6l-2.1 4.4h-3.1l10-21.9 10 21.9h-3.1z m-10.2-7.5h6.6l-3.3-7z' })
        )
    );
};

exports.default = IoSocialAngularOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-angular-outline.js
// module id = 2444
// module chunks = 0